import { useMemo } from 'react';
import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import type { SiteMeta } from '@src/types/SiteMeta';
import { getUnitName } from '../utils/incidentUtils';

export function useSelectedUnitNames(
  selectedUnits: GridRowSelectionModel | undefined,
  siteMeta: SiteMeta,
): ReadonlyArray<string> {
  return useMemo((): ReadonlyArray<string> => {
    if (!selectedUnits || selectedUnits.length === 0) {
      return [];
    }

    return selectedUnits
      .map((unitId) => getUnitName(String(unitId), siteMeta))
      .filter(Boolean);
  }, [selectedUnits, siteMeta]);
}
